import React from 'react';
import { useSelector } from 'react-redux';
import { WheelLayout } from 'components/WheelLayout';
import {
  PauseDetailsToggle,
  PauseDetailsOverlayContainer,
} from 'components/PauseDetails';
import { getScopePartsGoal } from 'lib/selectors/getScopePartsGoal';
import { ExpectedItems } from 'components/TabsCommon';
import {
  WheelComponent,
  QualityMeter,
  CycleHistory,
  CyclesFinished,
} from './components';

export const CycleCount = () => {
  const { expectedCyclesNow } = useSelector(getScopePartsGoal);

  return (
    <PauseDetailsOverlayContainer>
      <WheelLayout
        id="cycle-count-page"
        topLeft={<CyclesFinished />}
        topRight={<ExpectedItems value={expectedCyclesNow} />}
        bottomRight={<CycleHistory />}
        bottomLeft={<QualityMeter />}
        wheel={<WheelComponent />}
      />
      <PauseDetailsToggle />
    </PauseDetailsOverlayContainer>
  );
};
